import React, { useEffect, useRef, useState } from "react";
import { Form, Input, InputNumber, Modal, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";

const { TextArea } = Input;
const SpaTransferModal = ({ open, handleCancel, handleFetchData, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { saving } = useSelector((state) => state.save);

  const onFinish = async (data) => {
    data.apbId = prodd.apbId;
    const res = await dispatch(
      save({
        ...data,
        url: "api/v1/active-paybill/spa-business-transfer-from-mmf-to-utility",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  useEffect(() => {
    if (prodd) {
      form.setFieldsValue(prodd);
    } else {
      form.resetFields();
    }
  }, [prodd, form]);

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={
          prodd
            ? `Transfer from ${prodd?.apbNumber} - ${prodd?.apbType}`
            : "Add paybill details"
        }
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <div className="grid lg:grid-cols-2 grid-cols-1 gap-10">
            <Form.Item
              name="apbWorkAmnt"
              label="Working Amount"
              rules={[
                {
                  required: true,
                  message: "Enter working amount",
                },
              ]}
            >
              <InputNumber
                readOnly
                min={0}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                className="input flex"
              />
            </Form.Item>

            <Form.Item
              name="apbUtilityAmnt"
              label="Utility Amount"
              rules={[
                {
                  required: true,
                  message: "Enter utility Amount",
                },
              ]}
            >
              <InputNumber
                readOnly
                min={0}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                className="input flex"
              />
            </Form.Item>
          </div>

          <Form.Item
            name="amount"
            label="Amount"
            rules={[
              {
                required: true,
                message: "Enter Amount",
              },
            ]}
          >
            <InputNumber
              min={0}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              className="input flex"
            />
          </Form.Item>
          <Form.Item
            name="accountReference"
            label="Account Reference"
            rules={[
              {
                required: true,
                message: "Enter account reference",
              },
            ]}
          >
            <Input className="input" />
          </Form.Item>
          <Form.Item
            name="remarks"
            label="Remarks"
            rules={[
              {
                required: true,
                message: "Enter Remarks",
              },
            ]}
          >
            <TextArea rows={4} className="input-textarea" />
          </Form.Item>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn-2"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default SpaTransferModal;
